/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Page from 'material/structure/page/page';
import Content from 'material/structure/content/content';
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import BodyCopy from 'material/copy/bodycopy/bodycopy';
import CTAs from 'material/ctas/ctas';
import Button from 'material/ctas/button/button_container';
import Tabs from 'material/tabs/tabs';
import Tab from 'material/tabs/tab/tab';
import Preview from 'material/ctas/preview/preview_container';
import CodeSelector from 'material/embeds/codeselector/codeselector_container';
import Confetti from 'react-dom-confetti'; //https://daniel-lundin.github.io/react-dom-confetti/
import EditEmbedName from 'pages/dashboard/embeds/management/editembedname/editembedname_container';
// utils
import { browserAlertOff } from 'utils/embeds/browser_alert';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/code/code_styles';



/* ========== ~~~~~~~~~~ PAGE : CODE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class CodePage extends Component {
    /* <<<<<<<<<< LIFECYCLE FUNCTIONS >>>>>>>>>> */
    constructor(props) {
        super(props);
        this.confettiConfig = { 
            angle: 90,
            spread: 360,
            startVelocity: 66,
            elementCount: 200,
            decay: 0.9
        };
        this.timer = null;
        this.state = { showConfetti: false };
        this.handleReturnToLibraryClick = this.handleReturnToLibraryClick.bind(this);
        this.handleCreateEmbedClick = this.handleCreateEmbedClick.bind(this);
    }
    componentDidMount() {
        this.timer = this.props.isNewEmbedFlow ? setTimeout(() => {
            this.setState({ showConfetti: true });
            //fetches clients embeds after an embed is created so they cant create duplicate embeds if they route directly to createEmbed from this component
            this.props.getClientEmbedsData(this.props.accountUUID);
            // disable browser alerts. Alerts are enabled in the EmbedManagement component
            browserAlertOff();
            clearTimeout(this.timer);
        }, 1000) : null;
        if(!this.props.isNewEmbedFlow && (!this.props.headerCode && !this.bodyCode)) this.props.getEmbedCode(this.props.siteUUID, this.props.embedUUID)
    }
    componentWillUnmount() {
        clearTimeout(this.timer);
    }
    /* >>>>>>>>>> CUSTOM FUNCTIONS <<<<<<<<<< */
    isStep() {
        return this.props.currentStepPage !== null || this.props.currentStepPage !== undefined ? 'step' : 'standard';
    }
    handleReturnToLibraryClick() {
        this.props.moveToPage('dashboard/embeds');
    }
    handleCreateEmbedClick() {
        this.props.displayModal(true, <EditEmbedName createEmbed={true} updateEmbed={false}/>)
    }
    /* /////////////// RENDER \\\\\\\\\\\\\\\ */
    render() {
        return(
            <Page name={`code`} klass={`${this.props.classes.code} ${this.isStep()}`}>
                <Content>
                    {this.props.isNewEmbedFlow ? <Confetti active={this.state.showConfetti} config={this.confettiConfig} /> : null}
                    <Copy>
                        <Title>
                            <h2>Your Embed "<strong>{this.props.embedName}</strong>" is ready to go live!</h2>
                        </Title>
                        <BodyCopy>
                            <p>Please pick from the code options below to implement your Embed and start generating <strong>Revenue and Engagement</strong>!</p>
                        </BodyCopy>
                    </Copy>
                    <Tabs id={`codeselect`}>
                        <Tab id={`websitecode`} title={`Your Website Code`}>
                            <CodeSelector type={`websitecode`} />
                        </Tab>
                        <Tab id={`dfp`} title={`DFP`}>
                            <CodeSelector type={`dfp`} />
                        </Tab>
                        {/*
                        <Tab id={`instantarticle`} title={`Instant Article`}>
                            <CodeSelector type={`instantarticle`} />
                        </Tab>
                        <Tab id={`amp`} title={`Google AMP`}>
                            <CodeSelector type={`amp`} />
                        </Tab>
                        <Tab id={`inapp`} title={`In-App`}>
                            <CodeSelector type={`inapp`} />
                        </Tab>
                        */}
                    </Tabs>
                    <div className={`controls`}>
                        <Preview />
                        <CTAs>
                            <Button type={`custom`} handleClick={this.handleCreateEmbedClick} variant={`system`} name={`createembed`} text={`Create Another Embed`} />
                            <Button type={`custom`} handleClick={this.handleReturnToLibraryClick} variant={`system`} name={`returntolibrary`} text={`Return to Library`} />
                        </CTAs>
                    </div>
                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(CodePage);
